import { useCallback, useEffect, useRef, useState } from "react"
import { InputGroup } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { forwardRef } from "react";

import drag_img from '../../assets/images/drag.svg'
import minimize_img from '../../assets/images/minimize.svg'

export default function FieldCard ({field, t, Ekey, handleUpdateField}) {

    const ref = useRef()
    const [activeAnswer, setActiveAnswer] = useState(null)

    const handleUpdateCoiches = (value, card_index, type, index) => {
        console.log(value, card_index, type, index)
        if(index === 'new'){
            setActiveAnswer(field?.choices?.length || 0)
        }
        handleUpdateField(value, card_index, 'choices', index)
    }

    const dragEnded = (param) => {
        const { source, destination } = param;
        let _arr = [...field.choices];
        //extracting the source item from the list
        const _item = _arr.splice(source.index, 1)[0];
        //inserting it at the destination index.
        _arr.splice(destination.index, 0, _item);
        handleUpdateField(_arr, Ekey, 'choices');
    };

    useEffect(() => {
        if (ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "end" });
        }
    }, []);

    return (
        <div key={Ekey} ref={ref} onClick={()=>(!field.is_open ? handleUpdateField(!field.is_open, Ekey, 'is_open') : null)} className={`${field.is_open ? 'active' : ''}`}>
            {!field?.is_open ?
                <>
                    <h5>{field.field_names.it}</h5>
                    {t.users.settings.fields[field.field_type]}
                </> :
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <Form.Check // prettier-ignore
                            type="switch"
                            id={`field-${Ekey}-switch`}
                            label={t.users.settings.fields.active}
                            checked={!field.disabled}
                            onChange={()=>handleUpdateField(!field.disabled, Ekey, 'disabled')}
                        />
                        <img src={minimize_img} onClick={()=>handleUpdateField(!field.is_open, Ekey, 'is_open')} className="pointer" />
                    </div>
                    <Form.Group className="mt-2" controlId={`field_id_${Ekey}_it`}>
                        <Form.Label>ID</Form.Label>
                        <Form.Control type="text" value={field.field_id} onChange={(e)=>handleUpdateField(e.target.value, Ekey, 'field_id')} disabled={field.field_type !== 'custom_attribute'} />
                    </Form.Group>
                    <Form.Group className="mt-2" controlId={`field_names_${Ekey}_it`}>
                        <Form.Label>{t.users.settings.fields.field_name}</Form.Label>
                        <div className="d-flex">
                            <InputGroup className="">
                                <InputGroup.Text id="basic-addon1">IT</InputGroup.Text>
                                <Form.Control type="text" value={field.field_names?.it || ''} onChange={(e)=>handleUpdateField(e.target.value, Ekey, 'field_names','it')} />
                            </InputGroup>
                            <InputGroup className="ms-2">
                                <InputGroup.Text id="basic-addon1">EN</InputGroup.Text>
                                <Form.Control type="text" value={field.field_names?.en || ''} onChange={(e)=>handleUpdateField(e.target.value, Ekey, 'field_names','en')} />
                            </InputGroup>
                        </div>
                    </Form.Group>
                    <div className="d-flex mt-3">
                        <Form.Group controlId={`field_type_${Ekey}_it`} className="col-6">
                            <Form.Label>{t.users.settings.fields.field_type}</Form.Label>
                            <Form.Select value={field.field_type} onChange={(e)=>handleUpdateField(e.target.value, Ekey, 'field_type')}>
                                <option value="text">{t.users.settings.fields.text}</option>
                                <option value="datetime">{t.users.settings.fields.datetime}</option>
                                <option value="singular">{t.users.settings.fields.singular}</option>
                                <option value="multiple">{t.users.settings.fields.multiple}</option>
                                <option value="custom_attribute">{t.users.settings.fields.custom_attribute}</option>
                            </Form.Select>
                        </Form.Group>
                        <Form.Group controlId={`field_level_${Ekey}_it`} className="col-6 ms-2">
                            <Form.Label>{t.users.settings.fields.field_level}</Form.Label>
                            <Form.Select value={field.field_level} onChange={(e)=>handleUpdateField(e.target.value, Ekey, 'field_level')}>
                                <option value="0">{t.users.settings.fields.level_0}</option>
                                <option value="1">{t.users.settings.fields.level_1}</option>
                                <option value="2">{t.users.settings.fields.level_2}</option>
                            </Form.Select>
                        </Form.Group>
                    </div>
                    {field.field_type === 'singular' || field.field_type === 'multiple' ?
                        <div className="d-flex mt-3">
                            <Form.Group controlId={`answers_${Ekey}_it`} className="">
                                <Form.Label>{t.users.settings.fields.answers}</Form.Label>
                                <DragDropContext onDragEnd={dragEnded}>
                                    <Droppable droppableId={`answers-wrapper-${Ekey}`}>
                                        {(provided, snapshot) => (
                                            <Answers ref={provided.innerRef} {...provided.droppableProps}>
                                            {field?.choices?.map((a,index) => {
                                                return (
                                                <Draggable
                                                    draggableId={`answer-${index}`}
                                                    index={index}
                                                    key={`${index}`}
                                                    >
                                                    {(_provided, _snapshot) => (
                                                        <Answer 
                                                            ref={_provided.innerRef}
                                                            dragHandleProps={_provided.dragHandleProps}
                                                            {..._provided.draggableProps}
                                                            snapshot={_snapshot}
                                                            isInFocus={index === activeAnswer}
                                                            key={index} index={index} id={index} Ekey={Ekey} text={a} handleUpdate={handleUpdateCoiches}
                                                        />
                                                    )}
                                                </Draggable>)
                                            })}
                                            {provided.placeholder}
                                            <Form.Control className="w-100" type="text" value={''} onChange={(e)=>handleUpdateCoiches(e.target.value, Ekey, 'choices', 'new')} />
                                        </Answers>
                                    )}
                                    </Droppable>
                                </DragDropContext>
                                        
                            </Form.Group>
                        </div>
                    : null}
                </div>
            }
            
        </div>
    )
}

const Answers = forwardRef(({ children, ...props }, ref) => {
  return (
    <div ref={ref} className="answers">
      {children}
    </div>
  );
});

const Answer = forwardRef(
  ({ text, date, index, dragHandleProps, snapshot, Ekey, isInFocus=false, handleUpdate, ...props }, ref) => {
    const inputRef = useRef(null)

    useEffect(()=>{
        if(isInFocus)
            inputRef.current.focus()
    },[isInFocus])

    return (
      <div
        ref={ref}
        {...props}
        className={
          "d-flex mb-2"
        }
      >
            <img src={drag_img} className="me-2" {...dragHandleProps} />
           <Form.Control ref={inputRef} className="w-100" type="text" value={text || ''} onChange={(e)=>handleUpdate(e.target.value, Ekey, 'choices', index)} />
      </div>
    );
  }
);